import React from "react"
import PropTypes from "prop-types"
import { withRouter } from '../../../lib/withRouter'
import { connect } from "react-redux"
import { formatDate, getPath, getViewPatientData } from "../../../lib"
import PatientSidebar from "../../ViewData/PatientSidebar"

export class CCAHClaimTab extends React.Component {
    tableColumns = [
        { key: "CapMonth", label: "Cap Month", className: "text-center" },
        { key: "PatientFullName", label: "Patient Full Name" },
        { key: "MemberCIN", label: "Member CIN", className: "text-center" },
        { key: "ServiceEndDate", label: "Service End Date", className: "text-center", render: (item) => item.ServiceEndDate ? formatDate(item.ServiceEndDate) : "-" },
        { key: "TotalBilledAmount", label: "Total Billed Amount", className: "text-right" },
        { key: "InvoiceNumber", label: "Invoice Number", className: "text-center" },
        { key: "Invoice", label: "Invoice", className: "text-center" },
        {
            key: "Status", label: "Status", className: "text-center", render: (item) => {
                if (item.Status === "Billed Not Paid") {
                    return (
                        <span
                            className="label"
                            style={{
                                backgroundColor: "#DC3545",
                                color: "#fff"
                            }}
                        >
                            Not Paid
                        </span>
                    )
                } else {
                    return (
                        <span
                            className="label"
                            style={{
                                backgroundColor: "#28A745",
                                color: "#fff"
                            }}
                        >
                            Paid
                        </span>
                    )
                }
            }
        },
    ];

    static propTypes = {
        query: PropTypes.object,
        selection: PropTypes.object,
        location: PropTypes.object,
        settings: PropTypes.object,
        urlParams: PropTypes.object,
        dispatch: PropTypes.func,
        router: PropTypes.object
    };

    constructor(props) {
        super(props);
        this.state = {
            claimListResult: null,
            capMonthDropdown: [],
            statusFilter: "",
            capMonthFilter: "",
            memberNameFilter: "",
            paidSummary: null,
            notPaidSummary: null,
            paidTotalBilled: 0,
            notPaidTotalBilled: 0,
            loading: false,
            error: null,
            currentPage: 1,
            hasNextPage: false,
            pageSize: 100,
            sortKey: null,
            sortDirection: null,
        };
    }

    componentDidMount() {
        this.fetchClaimData(1);
        this.fetchCapMonthData();
        this.fetchCCAHTotalData();
    }

    handleNextPage = () => {
        if (this.state.hasNextPage) {
            this.fetchClaimData(this.state.currentPage + 1);
        }
    };

    handlePrevPage = () => {
        if (this.state.currentPage > 1) {
            this.fetchClaimData(this.state.currentPage - 1);
        }
    };

    handlePageSizeChange = (e) => {
        const pageSize = parseInt(e.target.value);
        this.setState({ pageSize }, () => {
            this.fetchClaimData(1);
        });
    };

    fetchClaimData = async (page = 1) => {
        try {
            this.setState({ loading: true, error: null });

            let apiUrl = `${this.props.settings.server.url}/ccahclaims?page=${page}&size=${this.state.pageSize}`;

            if (this.state.statusFilter && this.state.statusFilter !== "") {
                apiUrl += `&Status=${encodeURIComponent(this.state.statusFilter)}`;
            }
            if (this.state.capMonthFilter && this.state.capMonthFilter !== "") {
                apiUrl += `&CapMonth=${encodeURIComponent(this.state.capMonthFilter)}`;
            }
            if (this.state.memberNameFilter) {
                apiUrl += `&membername=${encodeURIComponent(this.state.memberNameFilter)}`;
            }

            const data = await getViewPatientData({
                url: apiUrl,
                server: this.props.settings.server
            });

            const records = data?.claims || [];
            const hasNextPage = records.length === this.state.pageSize;

            // console.log("Fetched records:", records);

            this.setState({
                claimListResult: records,
                loading: false,
                currentPage: page,
                hasNextPage
            });
        } catch (error) {
            console.error("Search failed:", error);
            this.setState({ error: error.message, loading: false });
        }
    };

    fetchCapMonthData = async () => {
        try {

            let apiUrl = `${this.props.settings.server.url}/monthlist`;

            const data = await getViewPatientData({
                url: apiUrl,
                server: this.props.settings.server
            });

            const records = data?.summary.map(item => {
                return item?.ClaimMonth
            }) || []

            this.setState({
                capMonthDropdown: records,
            });
        } catch (error) {
            console.error("Search failed:", error);
            this.setState({ error: error.message });
        }
    };

    fetchCCAHTotalData = async () => {
        try {

            let apiUrl = `${this.props.settings.server.url}/ccahtotal`;

            if (this.state.capMonthFilter && this.state.capMonthFilter !== "") {
                apiUrl += `?CapMonth=${encodeURIComponent(this.state.capMonthFilter)}`;
            }

            const data = await getViewPatientData({
                url: apiUrl,
                server: this.props.settings.server
            });

            const summary = data?.summary || [];
            const paidSummary = summary.find(item => (item?.Status || "").toLowerCase() === "billed and paid");
            const notPaidSummary = summary.find(item => (item?.Status || "").toLowerCase() === "billed not paid");

            this.setState({
                paidSummary: paidSummary,
                notPaidSummary: notPaidSummary,
                paidTotalBilled: Number(paidSummary?.TotalBilled) || 0,
                notPaidTotalBilled: Number(notPaidSummary?.TotalBilled) || 0,
            });
        } catch (error) {
            console.error("Search failed:", error);
            this.setState({ error: error.message, loading: false });
        }
    };

    formatNumber(value) {
        return Number(value || 0).toLocaleString("en-US");
    }

    render() {
        if (
            this.props.location.search.includes("?_tab=demographics") ||
            this.props.location.search.includes("?_tab=conditions") ||
            this.props.location.search.includes("?_tab=tags")
        ) {
            const searchParams = new URLSearchParams(this.props.location.search);
            searchParams.delete("_resource");
            const cleanSearch = searchParams.toString() ? `?${searchParams.toString()}` : '';

            this.props.router.navigate(`/patient-list${cleanSearch}`);
            return null;
        }

        return (
            this.renderPatientsContent?.() || null
        )
    }

    renderRows(rows = []) {
        const claimListResult = rows;

        if (!claimListResult || claimListResult.length === 0) {
            return (
                <tr>
                    <td colSpan={this.tableColumns.length} className="text-center">No records found</td>
                </tr>
            );
        }

        return claimListResult.map((item, index) => (
            <tr
                key={item.DedupedClaimID || item.InvoiceNumber || index}
            >
                {this.tableColumns.map((column) => (
                    <td key={`${column.key}-${index}`} className={column.className || ""}>
                        {this.getDisplayValue(column.render ? column.render(item) : item[column.key])}
                    </td>
                ))}
            </tr>
        ));
    }

    getDisplayValue(value) {
        if (value === null || value === undefined) return "-";
        if (typeof value === "string") {
            const cleanedValue = value.trim();
            return cleanedValue === "" ? "-" : cleanedValue;
        }
        return value;
    }

    handleSort = (key) => {
        this.setState((prevState) => {
            if (prevState.sortKey !== key) {
                return { sortKey: key, sortDirection: "asc" };
            }

            if (prevState.sortDirection === "asc") {
                return { sortKey: key, sortDirection: "desc" };
            }

            return { sortKey: null, sortDirection: null };
        });
    };

    getSortIconClass = (key) => {
        const { sortKey, sortDirection } = this.state;

        if (sortKey !== key || !sortDirection) {
            return "fa-sort text-muted";
        }

        return sortDirection === "asc" ? "fa-sort-up" : "fa-sort-down";
    };

    getSortedClaims = () => {
        const { claimListResult, sortKey, sortDirection } = this.state;

        if (!claimListResult) return [];
        if (!sortKey || !sortDirection) return claimListResult;

        const sorted = [...claimListResult].sort((a, b) => {
            const aValue = a?.[sortKey];
            const bValue = b?.[sortKey];

            if (sortKey === "ServiceEndDate") {
                const aDate = aValue ? new Date(aValue).getTime() : 0;
                const bDate = bValue ? new Date(bValue).getTime() : 0;
                return aDate - bDate;
            }

            if (sortKey === "TotalBilledAmount") {
                const aNumber = Number(aValue ?? 0);
                const bNumber = Number(bValue ?? 0);
                return aNumber - bNumber;
            }

            const aString = (aValue ?? "").toString().toLowerCase();
            const bString = (bValue ?? "").toString().toLowerCase();
            return aString.localeCompare(bString);
        });

        return sortDirection === "desc" ? sorted.reverse() : sorted;
    };


    renderPatientsContent() {
        const { loading, error, claimListResult, currentPage, hasNextPage, paidTotalBilled, notPaidTotalBilled, paidSummary, notPaidSummary } = this.state;
        const sortedClaims = this.getSortedClaims();

        if (loading) {
            return <div className="patient-search-loading">
                <i className="fa fa-spinner spin" /> Loading. Please wait...
            </div>;
        }

        if (error) {
            return <p className="text-danger">Error: {error}</p>;
        }

        const searchHeader = (
            <div className="panel-default">
                <div className="panel-heading" style={{ padding: "5px 15px" }}>
                    <div className="row d-flex align-items-center">
                        <div className="col-md-6">
                            <b className="text-primary">
                                <i className="fa fa-address-card-o" /> CCAH Claims
                                <span style={{ marginLeft: "12px", color: "#505050", fontWeight: 400, fontSize: '12px' }}>
                                    Paid:&nbsp;
                                    <span style={{ color: "#2e7d32" }}>${this.formatNumber(paidTotalBilled)}</span>
                                    <span style={{ color: "#8c8c8c" }}>(Claims: {this.formatNumber(paidSummary?.TotalClaims)})</span>
                                </span>
                                <span style={{ marginLeft: "12px", color: "#505050", fontWeight: 400, fontSize: '12px' }}>
                                    Not Paid:&nbsp;
                                    <span style={{ color: "#c62828" }}>${this.formatNumber(notPaidTotalBilled)}</span>
                                    <span style={{ color: "#8c8c8c" }}>(Claims: {this.formatNumber(notPaidSummary?.TotalClaims)})</span>
                                </span>
                            </b>
                        </div>
                        <div className="col-md-6">
                            <div className="row">
                                <div className="col-md-4">
                                    <select
                                        name="statusFilter"
                                        id="statusFilter"
                                        value={this.state.statusFilter}
                                        onChange={(e) => this.setState({ statusFilter: e.target.value })}
                                        className="form-control input-sm"
                                    >
                                        <option value="">Search by Status</option>
                                        <option value="Billed And Paid">Paid</option>
                                        <option value="Billed Not Paid">Not Paid</option>
                                    </select>
                                </div>
                                <div className="col-md-4">
                                    <select
                                        name="capMonthFilter"
                                        id="capMonthFilter"
                                        value={this.state.capMonthFilter}
                                        onChange={(e) => this.setState({ capMonthFilter: e.target.value })}
                                        className="form-control input-sm"
                                    >
                                        <option value="">Search by Month</option>
                                        {this.state.capMonthDropdown.map((item, index) => {
                                            return (
                                                <option key={'capMonth' + index} value={item}>{item}</option>
                                            )
                                        })}
                                    </select>
                                </div>
                                <div className="col-md-4 pull-right">
                                    <div className="input-group">
                                        <input
                                            type="text"
                                            className="form-control input-sm"
                                            placeholder="Search by Member Name..."
                                            value={this.state.memberNameFilter}
                                            onChange={(e) => this.setState({ memberNameFilter: e.target.value })}
                                            onKeyPress={(e) => {
                                                if (e.key === 'Enter') {
                                                    this.fetchClaimData(1);
                                                }
                                            }}
                                        />
                                        <span className="input-group-btn">
                                            <button
                                                className="btn btn-primary btn-sm"
                                                onClick={() => {
                                                    this.fetchClaimData(1)
                                                    if (this.state?.capMonthFilter) {
                                                        this.fetchCCAHTotalData();
                                                    }
                                                }}
                                            >
                                                <i className="fa fa-search" />
                                            </button>
                                        </span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );

        if (!claimListResult || claimListResult.length === 0) {
            return (
                <>
                    {searchHeader}
                    <p>No patient data available.</p>
                </>
            );
        }

        const hasPrev = currentPage > 1;
        const hasNext = hasNextPage;

        return (
            <>
                <div className="tab-content-wrapper" style={{ marginBottom: "2.5rem" }}>
                    {searchHeader}
                    <div className="panel-default">

                        <div className="table-responsive">
                            <table className="table table-condensed table-hover table-striped table-bordered">
                                <thead>
                                    <tr>
                                        {this.tableColumns.map((column) => (
                                            <th key={column.key} className="text-center">
                                                <button
                                                    type="button"
                                                    onClick={() => this.handleSort(column.key)}
                                                    style={{
                                                        border: "none",
                                                        background: "transparent",
                                                        padding: 0,
                                                        fontWeight: 600,
                                                        cursor: "pointer"
                                                    }}
                                                >
                                                    {column.label}{" "}
                                                    <i className={`fa ${this.getSortIconClass(column.key)}`} />
                                                </button>
                                            </th>
                                        ))}
                                    </tr>
                                </thead>
                                <tbody>
                                    {this.renderRows(sortedClaims)}
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>

                {/* Footer with Pagination */}
                <div className="app-footer" style={{ position: "fixed", bottom: 0, width: "100%", backgroundColor: "#f5f5f5", borderTop: "1px solid #ddd" }}>
                    <div className="container-fluid" style={{ width: "100%" }}>
                        <div className="row">
                            <div className="col-xs-3 col-sm-4 text-right">
                                <a
                                    href="#prev"
                                    onClick={e => {
                                        e.preventDefault();
                                        if (hasPrev) this.handlePrevPage();
                                    }}
                                    style={{
                                        color: hasPrev ? '#007bff' : '#6c757d',
                                        cursor: hasPrev ? 'pointer' : 'not-allowed',
                                        textDecoration: 'none'
                                    }}
                                >
                                    <i className="fa fa-arrow-left" /> Prev
                                </a>
                            </div>
                            <div className="col-xs-6 col-sm-4 text-center">
                                <span className="pagination-status">
                                    Page {currentPage}
                                </span>
                            </div>
                            <div className="col-xs-3 col-sm-4 text-left">
                                <a
                                    href="#next"
                                    onClick={e => {
                                        e.preventDefault();
                                        if (hasNext) this.handleNextPage();
                                    }}
                                    style={{
                                        color: hasNext ? '#007bff' : '#6c757d',
                                        cursor: hasNext ? 'pointer' : 'not-allowed',
                                        textDecoration: 'none'
                                    }}
                                >
                                    Next <i className="fa fa-arrow-right" />
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
            </>
        );
    }
}

export default connect(state => state)(withRouter(CCAHClaimTab));
